import React from "react";
import NewSaleTMotos from "../pages/newSaleTMotos";

export const genericDashboardRoutes = [
  {
    path: "/persona/reportes",
    title: "Reportes Socios",
    buttonsList: [
      {
        label: "Ventas por Link",
        reportName: "RegistroAltasMensualesVD",
        params: {
          canal: ["MEDILINE"],
          seller_tokens: ["ALL"],
        },
      },
      // { label: "Carta Vigente O.S.", reportName: "Carta Vigente Obra Social" },
      { label: "Cartera Bruta", reportName: "Cartera" },
      { label: "Listado de BNF", reportName: "Listado de BNF" },
      { label: "Cobros del Mes", reportName: "Cobros del Mes" },
      { label: "Cápitas", reportName: "Cápitas", newRow: true },
      { label: "Reporte Altas Gerencia", reportName: "Reporte Altas Gerencia", newRow: true },
      // {
      //   label: "Notas de credito a emitir",
      //   reportName: "NC a emitir",
      //   active: false,
      // },
    ],
  },
    {
    path: "/persona/bajas_datos",
    title: "Bajas de Datos",
    buttonsList: [
      { label: "Cartera Morosa", reportName: "CarteraMorosa" },
      // { label: "Carta Vigente O.S.", reportName: "Carta Vigente Obra Social" },
      { label: "Reporte Bajas", reportName: "Bajas Socios" },
      // { label: "Listado de BNF", reportName: "Listado de BNF" },
      // { label: "Cobros del Mes", reportName: "Cobros del Mes" },
      // { label: "Cápitas", reportName: "Cápitas", newRow: true },
      // { label: "Reporte Altas Gerencia", reportName: "Reporte Altas Gerencia", newRow: true },
    ],
  },
  {
    path: "/reportes/consultas",
    title: "Reportes consultas",
    buttonsList: [
      { label: "Consultas", reportName: "Consultas" },
      { label: "Recetas x periodo", reportName: "Recetas Emitidas Periodo" },
      { label: "Datos por Año", reportName: "Datos Del Año" },
    ],
  },
  {
    path: "/canales/tmotos",
    title: "Gestion de TMOTOS",
    buttonsList: [
      { label: "Altas Mensuales", reportName: "Registros Ventas TMotos" },
      {
        label: "Cuotas Mensuales",
        reportName: "Cuotas Mensuales",
        params: {
          texto: ["APROBADO"],
          texto_1: ["PROCESANDO"],
          texto_2: ["RETENIDO"],
          texto_3: ["CANCELADO"],
          texto_4: ["RECHAZADO"],
          texto_5: ["DEVOLUCION"],
        },
      },
      { label: "Ultimos Aprobados", reportName: "Ultimos Aprobados" },
      // {
      //   label: "Graficos de venta por mes",
      //   reportName: "Ventas por Mes",
      //   active: false,
      // },
      // {
      //   label: "Error de Datos",
      //   reportName: "Error Triunfo Motos",
      //   active: false,
      // },
      // { label: "Alta de socio", reportName: "NEW-SALE-TMOTOS", active: false },
    ],
    extraViews: { "NEW-SALE-TMOTOS": <NewSaleTMotos /> },
  },
  {
    path: "/canales/gallion",
    title: "Gestion de Gallion",
    buttonsList: [
      {
        label: "Altas Mensuales",
        reportName: "RegistroAltasMensualesVD",
        params: {
          canal: ["REDEX"],
          seller_tokens: ["ALL"],
        },
      }
    ],
    extraViews: { "NEW-SALE-TMOTOS": <NewSaleTMotos /> },
  },
];
